module.exports = __webpack_public_path__ + "static/media/add-notes.521f7264.svg";